import '.n{width:100%;}.ssr-plugin'
import '.bl{padding-inline:1rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.as{justify-content:center;}.ssr-plugin'
import '.bf{position:sticky;}.ssr-plugin'
import '.bg{top:0px;}.ssr-plugin'
import '.bm{z-index:10;}.ssr-plugin'
import '.bi{background:var(--nav-bg);}.ssr-plugin'
import '.cv{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.ec{flex:1 1 auto;}.ssr-plugin'
import '.gp{overflow-x:auto;}.ssr-plugin'
import '.aa{min-width:0px;}.ssr-plugin'
import { styled } from 'inlines'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { TextLink } from '@app/components/core/link/TextLink'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'

const ENTITY_NAME_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

export type GeographyNavBarTab = {
  value: string
  label: string
  isVisible: boolean
}

export type GeographyNavBarShellProps = {
  isMobile: boolean
  shouldShowEntityName: boolean
  entityName: string
  homePath: string
  tab: string
  tabs: GeographyNavBarTab[]
  onSelectTab: (key: string) => void
}

export const GeographyNavBarShell = ({
  isMobile,
  shouldShowEntityName,
  entityName,
  homePath,
  tab,
  tabs,
  onSelectTab,
}: GeographyNavBarShellProps) => (
  <nav className="n bl a as bf bg bm bi cv"
  >
    <ResponsiveContainer
      style={{
        background: 'var(--nav-bg)',
        display: 'flex',
        justifyContent: shouldShowEntityName ? 'space-between' : 'flex-end',
        alignItems: 'center',
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        minHeight: '3.5rem',
        gap: isMobile ? '0.5rem' : '1rem',
      }}
    >
      {shouldShowEntityName ? (
        <TextLink
          to={homePath}
          textStyle={{
            fontFamily: 'var(--font-heading)',
            ...getTitleLevelStyle(3, isMobile),
            whiteSpace: 'nowrap',
          }}
          containerStyle={{
            textDecoration: 'none',
            animation: ENTITY_NAME_APPEAR_ANIMATION,
          }}
        >
          {entityName}
        </TextLink>
      ) : null}

      <div className="ec a gp aa"
        style={{
          justifyContent: isMobile ? 'flex-start' : 'flex-end',}}
      >
        <TabsGroup
          selectedTab={tab}
          onSelectTab={onSelectTab}
          maxVisibleTabs={isMobile ? 3 : 6}
          tabs={tabs}
          tabItemStyle={{
            padding: isMobile ? '1rem 0.75rem' : '1.25rem 1rem',
          }}
        />
      </div>
    </ResponsiveContainer>
  </nav>
)
